import {
  enrollmentActions as enrollment,
  enrollmentActions,
} from 'src/store/enrollment/enrollment.actions';

const initialState = {
  pickupWeeks: {
    pickupWeeks: null,
    isFetching: false,
    error: false,
  },

  // state stored in server
  storedState: {
    storedState: null,
    isFetching: false,
    error: false,
  },

  saveEnrolment: {
    isFetching: false,
    error: false,
    response: null,
  },

  registeredEnrolmentsDates: {
    isFetching: false,
    error: false,
    registeredEnrolmentsDates: null,
  },

  registeredEnrolments: {
    isFetching: false,
    error: false,
    registeredEnrolments: {}, // date is key
  },

  returnForms: {
    pigs:{
      isFetching: false,
      data: null,
      error: false
    },
    sheep:{
      isFetching: false,
      data: null,
      error: false
    },
    cattle:{
      isFetching: false,
      data: null,
      error: false
    },
  },

  deleteRegisteredEnrolment: {
    isFetching: false,
    error: false,
  },
};

const enrollmentReducer = (state = initialState, action) => {
  switch (action.type) {
  case 'RESET_STORE':
    return initialState;
  case enrollment.fetchPickupWeeks().type:
    return {
      ...state,
      pickupWeeks: {
        ...state.pickupWeeks,
        isFetching: true,
        error: false,
        pickupWeeks: null,
      },
    };

  case enrollment.fetchPickupWeeksSuccess().type:
    return {
      ...state,
      pickupWeeks: {
        ...state.pickupWeeks,
        pickupWeeks: action.payload.pickupWeeks,
        isFetching: false,
        error: false,
      },
    };
  case enrollment.fetchPickupWeeksFailure().type:
    return {
      ...state,
      pickupWeeks: {
        ...state.pickupWeeks,
        pickupWeeks: null,
        isFetching: false,
        error: true,
      },
    };

  case enrollment.fetchStoredState().type:
    return {
      ...state,
      storedState: {
        ...state.storedState,
        isFetching: true,
        error: false,
        storedState: null,
      },
    };

  case enrollment.fetchStoredStateSuccess().type:
    return {
      ...state,
      storedState: {
        ...state.storedState,
        storedState: action.payload.storedState,
        isFetching: false,
        error: false,
      },
    };
  case enrollment.fetchStoredStateFailure().type:
    return {
      ...state,
      storedState: {
        ...state.storedState,
        storedState: null,
        isFetching: false,
        error: true,
      },
    };

  case enrollment.saveStoredState().type:
    return {
      ...state,
      storedState: {
        ...state.storedState,
        isFetching: true,
        error: false,
        storedState: null,
      },
    };

  case enrollment.saveStoredStateSuccess().type:
    return {
      ...state,
      storedState: {
        ...state.storedState,
        storedState: null,
        isFetching: false,
        error: false,
      },
    };
  case enrollment.saveStoredStateFailure().type:
    return {
      ...state,
      storedState: {
        ...state.storedState,
        storedState: null,
        isFetching: false,
        error: true,
      },
    };

  case enrollment.saveEnrolment().type:
    return {
      ...state,
      saveEnrolment: {
        ...state.saveEnrolment,
        isFetching: true,
        error: false,
        response: null,
      },
    };

  case enrollment.saveEnrolmentSuccess().type:
    return {
      ...state,
      saveEnrolment: {
        ...state.saveEnrolment,
        response: action.payload.enrolment,
        isFetching: false,
        error: false,
      },
    };
  case enrollment.saveEnrolmentFailure().type:
    return {
      ...state,
      saveEnrolment: {
        ...state.saveEnrolment,
        response: null,
        isFetching: false,
        error: action.payload.error,
      },
    };

  case enrollment.deleteRegisteredEnrolment().type:
    return {
      ...state,
      deleteRegisteredEnrolment: {
        ...state.deleteRegisteredEnrolment,
        isFetching: true,
        error: false,
      },
    };

  case enrollment.deleteRegisteredEnrolmentSuccess().type:
    return {
      ...state,
      deleteRegisteredEnrolment: {
        ...state.deleteRegisteredEnrolment,
        isFetching: false,
        error: false,
      },
    };
  case enrollment.deleteRegisteredEnrolmentFailure().type:
    return {
      ...state,
      deleteRegisteredEnrolment: {
        ...state.deleteRegisteredEnrolment,
        isFetching: false,
        error: true,
      },
    };

  case enrollment.resetStoredState().type:
    return {
      ...state,
      storedState: {
        ...state.storedState,
        isFetching: true,
        error: false,
        storedState: null,
      },
    };

  case enrollment.resetStoredStateSuccess().type:
    return {
      ...state,
      storedState: {
        ...state.storedState,
        storedState: null,
        isFetching: false,
        error: false,
      },
    };
  case enrollment.resetStoredStateFailure().type:
    return {
      ...state,
      storedState: {
        ...state.storedState,
        storedState: null,
        isFetching: false,
        error: true,
      },
    };

  case enrollmentActions.deleteRegisteredEnrolment().type:
    return {
      ...state,
      saveEnrolment: {
        ...state.saveEnrolment,
        isFetching: false,
        error: false,
        response: null,
      },
    };

  case enrollment.fetchRegisteredEnrolmentDates().type:
    return {
      ...state,
      registeredEnrolmentsDates: {
        ...state.registeredEnrolmentsDates,
        registeredEnrolmentsDates: null,
        isFetching: true,
        error: false,
      },
    };
  case enrollment.fetchRegisteredEnrolmentDatesSuccess().type:
    return {
      ...state,
      registeredEnrolmentsDates: {
        ...state.registeredEnrolmentsDates,
        registeredEnrolmentsDates: action.payload.dates,
        isFetching: false,
        error: false,
      },
    };

  case enrollmentActions.fetchRegisteredEnrolmentDatesFailure().type:
    return {
      ...state,
      registeredEnrolmentsDates: {
        ...state.registeredEnrolmentsDates,
        isFetching: false,
        error: true,
        registeredEnrolmentsDates: null,
      },
    };

  case enrollment.fetchRegisteredEnrolment().type:
    return {
      ...state,
      registeredEnrolments: {
        ...state.registeredEnrolments,
        isFetching: true,
        error: false,
      },
    };
  case enrollment.fetchRegisteredEnrolmentSuccess().type:
    return {
      ...state,
      registeredEnrolments: {
        ...state.registeredEnrolments,
        registeredEnrolments: {
          ...state.registeredEnrolments.registeredEnrolments,
          [action.payload.date]: action.payload.enrolment,
        },
        isFetching: false,
        error: false,
      },
    };

  case enrollmentActions.fetchRegisteredEnrolmentFailure().type:
    return {
      ...state,
      registeredEnrolments: {
        ...state.registeredEnrolments,
        isFetching: false,
        error: true,
      },
    };

  case enrollmentActions.resetEnrolmentDates().type:
    return {
      ...state,
      registeredEnrolmentsDates: initialState.registeredEnrolmentsDates,
    };
  case enrollment.fetchReturnForms().type:
    console.log("payload", action.payload);
    return {
      ...state,
      returnForms: {
        ...state.returnForms,
        [action.payload.animalKind]: {
          data: null,
          isFetching: true,
          error: false,
        }
      },
    };

  case enrollment.fetchReturnFormsSuccess().type:

    return {
      ...state,
      returnForms: {
        ...state.returnForms,
        [action.payload.animalKind]: {
          data: action.payload.returnForm,
          isFetching: false,
          error: false,
        }
      },
    };
  case enrollment.fetchReturnFormsFailure().type:
    return {
      ...state,
      returnForms: {
        ...state.returnForms,
        [action.payload.animalKind]: {
          data: null,
          isFetching: false,
          error: true,
        }
      },
    };
  default:
    return state;
  }
};

export default enrollmentReducer;
